import { TMaterialType } from '@cian/api-models/offer-card/v1/get-offer-data';

type textBuildMaterialTypeList = { [index in TMaterialType]?: string };

const text: textBuildMaterialTypeList = {
  aerocreteBlock: 'Газобетонный блок',
  block: 'Блочный',
  boards: 'Щитовой',
  brick: 'Кирпичный',
  foamConcreteBlock: 'Пенобетонный блок',
  gasSilicateBlock: 'Газосиликатный блок',
  monolith: 'Монолитный',
  monolithBrick: 'Монолитно-кирпичный',
  old: 'Cтарый фонд',
  panel: 'Панельный',
  stalin: 'Сталинский',
  wireframe: 'Каркасный',
  wood: 'Деревянный',
};

export function getBuildMaterialTypeText(index: TMaterialType) {
  return text[index];
}
